module.exports = __webpack_public_path__ + "assets/img/checked3-d9b6ee36.png";